import { exportConfigConstants } from '../constants';

const initialState = {
    isExportConfigsUpdated: true,

    exportConfigs: null,

    fetchingExportConfigs: false,
    fetchingExportConfigsError: null,

    creatingExportConfig: false,
    creatingExportConfigError: null,

    updatingExportConfig: false,
    updatingExportConfigError: null,

    deletingExportConfig: false,
    deletingExportConfigError: null,
};

export function exportConfigs(state = initialState, action) {
    switch (action.type) {
        case exportConfigConstants.FETCH_CONFIGS_REQUEST: {
            return {
                ...state,
                fetchingExportConfigs: true,
                exportConfigs: null,
                fetchingExportConfigsError: null,
            };
        }
        case exportConfigConstants.FETCH_CONFIGS_SUCCESS: {
            return {
                ...state,
                fetchingExportConfigs: false,
                exportConfigs: action.exportConfigs,
                fetchingExportConfigsError: null,
            };
        }
        case exportConfigConstants.FETCH_CONFIGS_FAILURE: {
            return {
                ...state,
                fetchingExportConfigs: false,
                fetchingExportConfigsError: action.error,
            };
        }

        case exportConfigConstants.CREATE_CONFIG_REQUEST: {
            return {
                ...state,
                creatingExportConfig: true,
                exportConfigs: null,
                creatingExportConfigError: null,
            };
        }
        case exportConfigConstants.CREATE_CONFIG_SUCCESS: {
            return {
                ...state,
                creatingExportConfig: false,
                exportConfigs: action.exportConfigs,
                creatingExportConfigError: null,
            };
        }
        case exportConfigConstants.CREATE_CONFIG_FAILURE: {
            return {
                ...state,
                creatingExportConfig: false,
                creatingExportConfigError: action.error,
            };
        }

        case exportConfigConstants.UPDATE_CONFIG_REQUEST: {
            return {
                ...state,
                updatingExportConfig: true,
                exportConfigs: null,
                updatingExportConfigError: null,
            };
        }
        case exportConfigConstants.UPDATE_CONFIG_SUCCESS: {
            return {
                ...state,
                creatingExportConfig: false,
                exportConfigs: action.exportConfigs,
                updatingExportConfigError: null,
            };
        }
        case exportConfigConstants.UPDATE_CONFIG_FAILURE: {
            return {
                ...state,
                updatingExportConfig: false,
                updatingExportConfigError: action.error,
            };
        }

        case exportConfigConstants.DELETE_CONFIG_REQUEST: {
            return {
                ...state,
                deletingExportConfig: true,
                exportConfigs: null,
                deletingExportConfigError: null,
            };
        }
        case exportConfigConstants.DELETE_CONFIG_SUCCESS: {
            return {
                ...state,
                deletingExportConfig: false,
                exportConfigs: action.exportConfigs,
                deletingExportConfigError: null,
            };
        }
        case exportConfigConstants.DELETE_CONFIG_FAILURE: {
            return {
                ...state,
                updatingExportConfig: false,
                deletingExportConfigError: action.error,
            };
        }

        default: {
            return state;
        }
    }
}
